function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, switchMap, map } from "rxjs/operators";
import { getUsersForLogisticsParty } from "../../../actions/userManagementActions";
import { GET_USERS_FOR_LOGISTICS_PARTY_FAILURE, GET_USERS_FOR_LOGISTICS_PARTY_REQUEST } from "../../../actions/userManagementActions/actionTypes";
import { pageRoutes } from "../../../routes";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, DEFAULT_ROUTE_CHANGE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { addNotification, pushRoute } from "../../../actions/ui";
import { UNAUTHORIZED_ERROR_MSG_FRAGMENT } from "../../../constants/error";
import isSiteExternal from "../../../utils/isSiteExternal";
export var getUsersForLogisticsPartyEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GET_USERS_FOR_LOGISTICS_PARTY_REQUEST), switchMap(function(action) {
        var _payload = action.payload, _history = _payload.history, history = _history === void 0 ? null : _history, logisticsPartyId = _payload.logisticsPartyId;
        return api.userManagementServices.getUsersForLogisticsParty({
            logisticsPartyId: logisticsPartyId
        }).pipe(map(function(response) {
            return getUsersForLogisticsParty.success(response.userList);
        }), catchError(function(err) {
            var ref, ref1;
            var errorActions = [
                getUsersForLogisticsParty.failure(err), 
            ];
            // TODO: temporarily kept this error msg fragment to compute if user dont have permission for GetUsersForLogisticsParty
            // Ideally 403 status should be used for unauthorized but currently 500 status is being sent by API
            var isUnauthorized = err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.includes(UNAUTHORIZED_ERROR_MSG_FRAGMENT);
            if (history && isSiteExternal()) {
                errorActions.push(pushRoute(history, pageRoutes.PROFILE_PAGE, DEFAULT_ROUTE_CHANGE_TIMEOUT));
            }
            errorActions.push(addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GET_USERS_FOR_LOGISTICS_PARTY_FAILURE,
                body: isUnauthorized ? "get_users_logistics_party_notifications.unauthorized" : "get_users_logistics_party_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
            return of.apply(void 0, _toConsumableArray(errorActions));
        }));
    }));
};
export default getUsersForLogisticsPartyEpic;

//# sourceMappingURL=index.js.map